export default __webpack_public_path__ + "static/media/knockout.50eb2bcb.svg";